import React from "react";
import AppContext from "../services/appContext";
import ViewPDP from "../components/ViewPDP/ViewPDP";

const ViewPdpView = () => (
  <AppContext.Consumer>
    {({ user, isDirtyForm, setIsDirtyForm, setNavModalProps }) => (
      <ViewPDP
        user={user}
        isDirtyForm={isDirtyForm}
        setIsDirtyForm={setIsDirtyForm}
        setNavModalProps={setNavModalProps}
      />
    )}
  </AppContext.Consumer>
);

export default ViewPdpView;
